var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFsLogoSansText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-label": "FamilySearch",
    viewBox: "0 0 24 24",
    width: 36,
    height: 36,
    fill: "currentColor",
    className: "svgCss_sw75ouf",
    style: {
      color: "currentcolor"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.61 19.84a5.26 5.26 0 002.28-3.19h-.61a3.31 3.31 0 01-2.07 2 9.86 9.86 0 011.25-8.08h-1.25a10.83 10.83 0 00-1.9 4.72 3.53 3.53 0 01-1.57-1.89h-.65a5.53 5.53 0 002.12 3.12v.32a10.72 10.72 0 002.7 7.16h3a10 10 0 01-3.28-4.15",
    fill: "#9b947b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11h5V6h-5zm4-1h-3V7h3zM12 17h5v-5h-5zm4-1h-3v-3h3z",
    fill: "#bbb7b1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11h4V7h-4zm3-1h-2V8h2z",
    fill: "#9b947b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8h3V5H6zm2.18-.82H6.82V5.82h1.36z",
    fill: "#bbb7b1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6h4V2h-4zm3.14-.86h-2.28V2.86h2.28zM4 14h5V9H4zm4-1H5v-3h3zM18 15h3v-3h-3zm2.1-.9h-1.2v-1.2h1.2z",
    fill: "#86ba40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsLogoSansText);
export default __webpack_public_path__ + "static/media/fs-logo-sans-text.372a4262d6f37c991fbeb37ef04f677c.svg";
export { ForwardRef as ReactComponent };